import { computed, inject, Injectable, signal } from '@angular/core';
import { ThemeService } from './theme.service';

export interface WhitelabelConfig {
  /** Logo for dark surfaces. */
  logo: string;
  /** Logo for light surfaces. */
  logoLight: string;
}

@Injectable({
  providedIn: 'root',
})
export class WhitelabelService {
  private theme = inject(ThemeService);

  private _config = signal<WhitelabelConfig>({
    logo: './images/logo-edudip.svg',
    logoLight: './images/logo-edudip-black.svg',
  });

  get config() {
    return this._config.asReadonly();
  }

  /** The logo matching the active colour scheme. */
  readonly logo = computed(() => {
    const config = this._config();
    return this.theme.isLight() ? config.logoLight : config.logo;
  });
}
